var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"verified user\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 58.2173V54.7037C2 41.1202 11.7671 30.1086 23.8155 30.1086",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.0195 31.2102C47.0196 28.7341 50.4752 28.7341 52.4754 31.2102C53.4863 32.4617 54.9393 33.1402 56.4389 33.0611C59.4061 32.9048 61.8498 35.6598 61.7111 39.005C61.641 40.6958 62.2428 42.3338 63.3529 43.4736C65.549 45.7286 65.549 49.6245 63.3529 51.8795C62.2428 53.0193 61.641 54.6574 61.7111 56.3481C61.8498 59.6934 59.4061 62.4484 56.4389 62.292C54.9393 62.213 53.4863 62.8914 52.4754 64.143C50.4752 66.619 47.0196 66.619 45.0195 64.143C44.0085 62.8914 42.5556 62.213 41.0559 62.292C38.0887 62.4484 35.645 59.6934 35.7837 56.3481C35.8538 54.6574 35.2521 53.0193 34.142 51.8795C31.9458 49.6245 31.9458 45.7286 34.142 43.4736C35.2521 42.3338 35.8538 40.6958 35.7837 39.005C35.645 35.6598 38.0887 32.9048 41.0559 33.0611C42.5556 33.1402 44.0085 32.4617 45.0195 31.2102Z",
    stroke: "#9E9E9E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M43.6475 47.6767L47.0476 51.5096L53.8472 43.8437",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.8155 30.1087C30.7001 30.1087 36.2814 23.8162 36.2814 16.0543C36.2814 8.29233 30.7001 2 23.8155 2C16.9307 2 11.3495 8.29233 11.3495 16.0543C11.3495 23.8162 16.9307 30.1087 23.8155 30.1087Z",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedUserIcon);
export default __webpack_public_path__ + "static/media/verified-user-icon.2de4ee63d5e60cc810b5eab87a22ac25.svg";
export { ForwardRef as ReactComponent };